import useAxios from 'hooks/useAxios';

export async function mintDevGameModeToken(sessionId) {
  const api = useAxios();

  try {
    const payload = {};
    if (sessionId) {
      payload.sessionId = sessionId;
    }

    const res = await api.post('/game-auth/dev/game-mode-token', payload);
    return res;
  } catch (err) {
    return err;
  }
}
